import { handleApiError } from 'utils/api';
import { env } from '../../constants';
import {
  CreateShiftFormData,
  ShiftCreateResponse,
  ShiftDetailsResponse
} from './types';

export const fetchShift = async (
  token: string | undefined,
  shiftId: string | undefined
): Promise<ShiftDetailsResponse | undefined> => {
  if (!token || !shiftId) {
    return undefined;
  }

  const response = await fetch(
    `${env.VITE_API_BASE_URL}/shifts/${shiftId}?orderBy=breaks&orderDirection=ASC`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    return undefined;
  }

  return response.json() as Promise<ShiftDetailsResponse>;
};

export const createShift = async (
  token: string | undefined,
  periodId: string | undefined,
  formData: CreateShiftFormData
): Promise<ShiftCreateResponse | undefined> => {
  if (!token || !periodId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/shifts`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not create shift');
  }

  return response.json() as Promise<ShiftCreateResponse>;
};

export const deleteShift = async (
  token: string | undefined,
  shiftId: string | undefined
): Promise<null | undefined> => {
  if (!token || !shiftId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/shifts/${shiftId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not delete shift');
  }

  return null;
};
